import React, { useEffect, useState } from 'react';
import { Field } from 'formik';

const LandingPageSearch = ({ setSearchValue, searchValue, searchText, setSearchText, setFieldValue, errors, touched }) => {

    const timeout = 600; // Example timeout value, adjust as needed

    useEffect(() => {
        const handler = setTimeout(() => {
            setSearchValue(searchText);

            // If user clears the search input
            if (searchText.trim() === "") {
                setFieldValue("services", "");
                setFieldValue("category", "");
            }
        }, timeout);

        return () => {
            clearTimeout(handler);
        };
    }, [searchText]);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    return (

        <div className="user-pro-search">
            <Field
                type="search"
                name='services'
                placeholder="What service are you looking for?"
                className="form-control LandingPageSearch"
                value={searchText}
                onChange={handleSearchChange}
            />

       
        </div>

    );
};

export default LandingPageSearch;


